import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import sumBy from 'lodash/sumBy';
export default {
  name: 'MediaUploadMultiple',
  props: {},
  data: function data() {
    return {
      urls: [],
      files: [],
      responsive: false,
      responsiveInput: false,
      bytes: 10485760 // 10MB

    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])),
  methods: {
    handleFileUpload: function handleFileUpload(files) {
      if (files && files.length) {
        var urls = [];
        this.files = files;
        files.forEach(function (file) {
          if (file.type.match('image')) {
            var reader = new FileReader();
            reader.addEventListener('load', function (event) {
              var result = event.target.result;
              urls.push(result);
            });
            reader.readAsDataURL(file);
          }
        });
        this.urls = urls;
        this.$emit('upload-files', files);
      }
    },
    clear: function clear() {
      this.files = [];
      this.urls = [];
      this.$emit('clear-files');
    },
    sum: function sum(objects) {
      return sumBy(objects, function (o) {
        return o.size;
      });
    },
    deleteFromList: function deleteFromList(index) {
      this.urls.splice(index, 1);
      this.files.splice(index, 1);
      this.$emit('upload-files', this.files);
    }
  }
};